<template>
  <div class="dashboard-view p-3">
    <b-row class="mb-2">
      <b-col
        v-for="c in cards"
        :key="c.title"
        cols="12"
        sm="4"
        lg="4"
        class="mb-1 d-flex"
      >
        <div class="stat-card flex-grow-1 d-flex align-items-center">
          <div
            class="icon-box d-flex align-items-center justify-content-center"
          >
            <feather-icon :icon="c.icon" size="26" />
          </div>
          <div class="ml-2">
            <small class="d-block">{{ c.title }}</small>
            <h3 class="mb-0 text-light">{{ c.value }}</h3>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="8" class="mb-2">
        <div class="chart-card h-100">
          <div class="mb-2">
            <h4 class="mb-0 text-light">{{ total }} Hrs</h4>
            <small>Total Spent time</small>
          </div>
          <apexchart
            height="240"
            type="area"
            :series="series"
            :options="options"
          />
        </div>
      </b-col>

      <b-col lg="4" class="mb-2">
        <div class="users-card h-100 d-flex flex-column">
          <h5 class="mb-3 text-light">Users</h5>

          <div
            v-for="u in users"
            :key="u.name"
            class="user-item d-flex align-items-center mb-2"
          >
            <b-avatar :src="u.avatar" size="38" class="mr-2" />
            <div>
              <p class="mb-0">From {{ u.name }}</p>
              <small class="text-white-50">{{ u.time }}</small>
            </div>
          </div>

          <div class="mt-auto view-all d-flex justify-content-end">
            View all
            <feather-icon icon="ArrowRightIcon" size="18" class="ml-1" />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BRow, BCol, BAvatar } from "bootstrap-vue";

export default {
  components: { BRow, BCol, BAvatar, apexchart: VueApexCharts },
  data() {
    return {
      cards: [
        { title: "All Experiments", value: 20, icon: "GridIcon" },
        { title: "Users", value: 260, icon: "UsersIcon" },
        { title: "Active/License", value: "260/500", icon: "KeyIcon" },
      ],
      total: 495,
      series: [{ data: [30, 32, 35, 38, 36, 40, 42, 41, 44, 45, 48, 50] }],
      options: {
        chart: {
          toolbar: { show: false },
          sparkline: { enabled: false },
          background: "transparent",
        },

        stroke: { curve: "smooth", width: 2, colors: ["#ffffff"] },

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.55,
            opacityTo: 0,
            stops: [0, 100],
            colorStops: [
              { offset: 0, color: "#cdd8ff", opacity: 0.55 },
              { offset: 100, color: "#ffffff", opacity: 0 },
            ],
          },
        },
        yaxis: {
          min: 20,
          max: 60,
          tickAmount: 4,
          labels: {
            show: true,
            formatter: (val) => `${val}Hrs`,
            style: { colors: "#e1e5ed", fontSize: "12px" },
            offsetX: -12,
          },
        },
        xaxis: {
          labels: { show: false },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        markers: {
          size: 5,
          colors: ["#fff"],
          strokeColors: "#fff",
          strokeWidth: 2,
        },

        dataLabels: {
          enabled: true,
          formatter(val, { dataPointIndex }) {
            return dataPointIndex === 6 ? "18 Hours" : "";
          },
          background: { enabled: false },
          style: { colors: ["#fff"], fontSize: "11px" },
        },

        grid: {
          strokeDashArray: 4,
          borderColor: "rgba(255,255,255,.18)",
          padding: { left: -10 },
        },

        tooltip: { theme: "dark" },
        colors: ["#ffffff"],
      },
      users: [
        {
          name: "Alex Manda",
          time: "Today, 16:36",
          avatar: "https://i.pravatar.cc/40?img=12",
        },
        {
          name: "Laura Santos",
          time: "Today, 08:49",
          avatar: "https://i.pravatar.cc/40?img=24",
        },
        {
          name: "Jadon S.",
          time: "Yesterday, 14:36",
          avatar: "https://i.pravatar.cc/40?img=30",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.stat-card,
.chart-card,
.users-card {
  backdrop-filter: blur(18px);
  background: rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  padding: 1rem 1.25rem;
  color: #fff;
}

.icon-box {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.15);
}

.dashboard-view .user-item p {
  font-size: 0.95rem;
}

.view-all {
  font-weight: 500;
  cursor: pointer;
}
.icon-box:before {
  content: "";
}
</style>
